import React from 'react';
import { Form, Select } from 'antd';
import { InfoCircleOutlined, OrderedListOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import { useFormPath } from './index';

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            const { listFieldProps, buildName } = useFormPath()

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const values = Array.isArray(data.values) ? data.values : []
            const prefix = data.multiple ? "[SELECT_MULTI]_" : "[SELECT]_"
            const finalName = prefix + data.fieldKey

            return (
                <Form.Item
                    {...(listFieldProps || {})}
                    label={`${data.label || t`Question`} :`}
                    name={buildName(finalName)}
                    rules={rules}
                    tooltip={tooltip}
                >
                    <Select
                        showSearch={false}
                        size={"middle"}
                        mode={data.multiple ? "multiple" : undefined}
                        placeholder={data.placeholder}
                    >
                        {values.map(i => (
                            <Select.Option key={i} value={i}>{i}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-select' + namespace,
        title: t`Liste déroulante`,
        description: t`Élément de formulaire utilisable.`,
        icon: <OrderedListOutlined />,
        iconColor: "#F39C12",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    multiple: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Choix multiple`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-étiquette`,
                            placeholder: t`Sous-étiquette`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                    defaultValue: {
                        type: "string",
                        uniforms: {
                            showIf: () => false,
                            label: t`Valeur par défaut`,
                        }
                    },
                    values: {
                        type: "array",
                        uniforms: {
                            label: t`Valeurs`,
                        },
                        items: {
                            type: "string",
                        },
                    },
                }
            },
        },
    }
}
